var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      ref: "dialog",
      attrs: { persistent: "", width: "290px" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              !_vm.allowEditing
                ? _c(
                    "v-text-field",
                    _vm._g(
                      _vm._b(
                        {
                          class: _vm.classText,
                          attrs: {
                            label: _vm.label,
                            "append-icon": "access_time",
                            readonly: "",
                            error: _vm.error,
                            "error-messages": _vm.errors,
                            dense: _vm.dense,
                            clearable: _vm.clearable,
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.modelText,
                            callback: function ($$v) {
                              _vm.modelText = $$v
                            },
                            expression: "modelText",
                          },
                        },
                        "v-text-field",
                        attrs,
                        false
                      ),
                      on
                    )
                  )
                : _vm._e(),
            ]
          },
        },
      ]),
      model: {
        value: _vm.modal,
        callback: function ($$v) {
          _vm.modal = $$v
        },
        expression: "modal",
      },
    },
    [
      _vm.allowEditing
        ? _c("v-text-field", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: "99:99",
                expression: "'99:99'",
              },
            ],
            class: _vm.classText,
            attrs: {
              label: _vm.label,
              "append-icon": "access_time",
              readonly: "",
              placeholder: "HH:mm",
              error: _vm.error,
              "error-messages": _vm.errors,
              dense: _vm.dense,
              clearable: _vm.clearable,
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.modelText,
              callback: function ($$v) {
                _vm.modelText = $$v
              },
              expression: "modelText",
            },
          })
        : _vm._e(),
      _vm.modal
        ? _c(
            "v-time-picker",
            {
              attrs: { "full-width": "", format: "24hr" },
              model: {
                value: _vm.modelHour,
                callback: function ($$v) {
                  _vm.modelHour = $$v
                },
                expression: "modelHour",
              },
            },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.modal = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.setTime(_vm.modelHour)
                    },
                  },
                },
                [_vm._v("OK")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }